const Utils = {
    /**
     * 合并默认的对象
     *  如果ori的值存在则不覆写
     *  如果ori值不存在则合并target的值
     *  如果是嵌套对象, 则递归处理
     * @param ori
     * @param target
     * @param _this
     */
    mergeObject (ori, target) {
        if (!ori || !target) return;

        Object.keys(target).forEach((item) => {
            if (ori[item] === undefined) { // 源不存在直接合并
                if (typeof target[item] === 'function') {
                    ori[item] = target[item]
                } else if (Utils.isArray(target[item])) {
                    ori[item] = [...target[item]]
                } else if (Utils.isObject(target[item])) {
                    if(moment.isMoment(target[item])) {
                        ori[item] = target[item];
                    } else {
                        ori[item] = Object.assign({}, target[item])
                    }
                } else {
                    ori[item] = target[item]
                }
            } else { // 源存在, 判断源是否是对象, 是对象则继续合并
                if (this.isArray(ori[item])) {

                } else if (Utils.isObject(ori[item])) {
                    if(moment.isMoment(target[item])) {
                        ori[item] = target[item];
                    } else {
                        this.mergeObject(ori[item], target[item])
                    }
                }
            }
        })
    },
    escape2Html(str) {
        if(!str) {return ''}
        let arrEntities = { 'lt': '<', 'gt': '>', 'nbsp': ' ', 'amp': '&', 'quot': '"' };
        str = str.replace(/&(lt|gt|nbsp|amp|quot);/ig, function (all, t) {
            return arrEntities[t];
        });
        const regex = new RegExp("<img", "gi");
        str = str.replace(regex, '<img class="rich-text-img" style="max-width: 100% !important; display:block; object-fit: contain; height: auto !important"');
        return str
    },
    
    getFileHttpUrl(url,serverDomain,prefix) {
        if(!url || url === '' || url.length == 0){
          return null;
        }
        if(!prefix) prefix = 'http'
      
        if(!serverDomain) serverDomain = window._CONFIG['staticDomainUrl'];
      
        if(url && url.indexOf(prefix) != -1 ){
          return url;
        }else{
          if(url.match(/^[\\|/][\S\S]*$/g)){
            return serverDomain + url;
          }
          return serverDomain + "/" + url;
        }
    },

    isUrl(val) {
        return /(http|https):\/\/[\w\-_]+(\.[\w\-_]+)?([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/.test(val);
    },
  }

export default Utils
